module.exports = __webpack_public_path__ + "img/tablet.e32cb6d6.png";